export const message = {
  form: `
    <p class="form-text error">
      {{ message }}
    </p>
  `,
};
